<template>
  <div>
    <BaseTitle :title="$t('content.anal_list')" />
    <v-row>
      <v-col v-for="(item, index) in items" :key="index" md="4">
        <div class="class-item" @click="gotoPage(item)">
          <svg-icon :icon="item.icon" width="198" height="140" />
          <strong class="class-item-title" v-if="item.icon == 'anal_teacher'">{{ $t('content.anal_teacher') }}</strong>
          <strong class="class-item-title" v-if="item.icon == 'anal_student'">{{ $t('content.anal_student') }}</strong>
          <strong class="class-item-title" v-if="item.icon == 'anal_class'">{{ $t('content.anal_class') }}</strong>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';

export default {
  name: 'MenuListLite',
  components: {
    BaseTitle
  },
  props: {
    type: {
      type: String
    }
  },
  computed: {
    ...mapGetters({})
  },
  data: () => ({
    items: []
  }),
  methods: {
    getData() {
      switch (this.type) {
        case 'school-admin':
          this.items = [
            { icon: 'anal_teacher', link: { name: 'AnalyticTeacherList' } },
            { icon: 'anal_student', link: { name: 'AnalyticStudentList' } },
            { icon: 'anal_class', link: { name: 'AnalyticClassList' } }
          ];
          break;
      }
    },
    gotoPage(item) {
      this.$router.push(item.link);
    }
  },
  created() {
    this.getData();
  }
};
</script>

<style lang="scss" scoped>
.class-item {
  display: flex;
  border-radius: 8px;
  box-shadow: 0 7px 16px 0 rgba(0, 0, 0, 0.13);
  background: #fff;
  padding: 10px;
  cursor: pointer;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 240px;

  &-title {
    color: #6d6d6d;
    display: block;
  }

  &:hover {
    background: #f8f8f8;
  }
}
</style>
